import styled from 'styled-components';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

export const CannotOpenAccountTitle = styled(Heading)`
  margin-bottom: ${({ theme }) => theme.spacings.abs24}px;
  display: block;
`;

export const ImageContainer = styled.div<{
  withMarginTop?: boolean;
}>`
  ${({ theme, withMarginTop }) =>
    withMarginTop ? `margin-top: ${theme.spacings.abs64}px;` : 'margin-top: 0;'}
  margin-bottom: ${({ theme }) => theme.spacings.abs32}px;
`;

export const MessageText = styled(Text)`
  display: block;
  width: 330px;
  margin-bottom: ${({ theme }) => theme.spacings.abs40}px;
  text-align: center;
`;

export const ModalContent = styled.div`
  text-align: center;
`;
